module.exports = __webpack_public_path__ + "img/rohan.725be0dc.webp";